jQuery(function($) {
  const videos = $('.video-container')

  videos.each(function() {
    const player = new Plyr($(this).find('.video-player'));
    const overlay = $(this).find('.video-overlay')

    player.on('play', event => {
      overlay.addClass('removed')
    });
  })
})
